import { AlertTriangle, Clock } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { STATUS_META } from "./resourceApi";

export function StatusBadge({ status, testId }) {
  const m = STATUS_META[status] || STATUS_META.draft;
  return (
    <Badge variant="outline" className={`text-2xs uppercase tracking-wider ${m.tone}`} data-testid={testId}>
      {m.label}
    </Badge>
  );
}

export function ReviewBadge({ state, date, testId }) {
  if (!state) return null;
  const overdue = state === "overdue";
  const Icon = overdue ? AlertTriangle : Clock;
  return (
    <span className={`inline-flex items-center gap-1 text-2xs font-medium ${overdue ? "text-red-700" : "text-amber-700"}`}
          data-testid={testId}>
      <Icon className="h-3 w-3" /> {overdue ? "Review overdue" : "Review due soon"}{date ? ` · ${date}` : ""}
    </span>
  );
}

export function AudienceBadge({ audience }) {
  const client = audience === "client";
  return (
    <Badge variant="outline"
           className={`text-2xs ${client ? "border-sky-300 bg-sky-50 text-sky-800" : "border-violet-300 bg-violet-50 text-violet-800"}`}>
      {client ? "Client" : "Practitioner"}
    </Badge>
  );
}
